import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig } from "./auth";

import {
    GET_PEOPLE_BY_PROJECTS,
    GET_PEOPLE_BY_PROJECT,
    GET_PEOPLE_BY_COMPANY,
    GET_PEOPLE_BY_REQUESTS,
    UPDATE_USER_COMPANY_ROLE,
    CLEAR_PEOPLE,
    SELECT_PERSON,
    GET_PEOPLE_BY_REQUEST_COUNT,
    SET_COMPANY_INVITES
} from "./types";

// GET PEOPLE BY PROJECTS
export const getPeopleByProjects = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/people/get-people-by-projects`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PEOPLE_BY_PROJECTS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET PEOPLE BY PROJECT
export const getPeopleByProject = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/people/get-people-by-project/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PEOPLE_BY_PROJECT,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET PEOPLE BY COMPANY
export const getPeopleByCompany = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/people/get-people-by-company`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PEOPLE_BY_COMPANY,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET REGISTRATION COMPANY INVITATIONS (BY USER PENDING)
export const getPeopleByRequests = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/auth/get-company-invite`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PEOPLE_BY_REQUESTS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET COUNT FOR COMPANY INVITATIONS (BY USER PENDING)
export const getPeopleByRequestCount = () => (dispatch, getState) => {
    console.log("should distpatch get count")
    axios
        .get(`/v0/api/auth/get-company-invite-count`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_PEOPLE_BY_REQUEST_COUNT,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// UPDATE COMPANY ROLES FOR OTHER USER (COMAPNY ADMIN ONLY) 
export const updateUserCompanyRole = (id, roles) => (dispatch, getState) => {
    axios
        .put(`/v0/api/people/update-role/${id}`, roles, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: UPDATE_USER_COMPANY_ROLE,
                    payload: { id: id, croles: roles },
                });
                dispatch(createMessage({ success: "Permissions updated." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// GET PENDING COMPANY INVITES (admin-initiated, replaces self-service company search/request)
export const getCompanyInvites = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/auth/company-invites`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: SET_COMPANY_INVITES, payload: res.data });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// SEND A COMPANY INVITE
export const sendCompanyInvite = (email, roles) => (dispatch, getState) => {
    axios
        .post(`/v0/api/auth/company-invites`, {email, ...roles}, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: SET_COMPANY_INVITES, payload: res.data });
                dispatch(createMessage({ success: "Invite sent" }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// REVOKE A PENDING COMPANY INVITE
export const revokeCompanyInvite = (inviteUuid) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/auth/company-invites/${inviteUuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({ type: SET_COMPANY_INVITES, payload: res.data });
                dispatch(createMessage({ success: "Invite revoked" }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// CLEAR PEOPLE
export const clearPeople = () => (dispatch) => {
    dispatch({
        type: CLEAR_PEOPLE,
        payload: null
    });
};

// SELECT USER TO VIEW DETAILS
export const selectPerson = (id) => (dispatch) => {
    dispatch({
        type: SELECT_PERSON,
        payload: id
    });
};